module.exports = __webpack_public_path__ + "img/p.b681eb1c.jpg";